<template>
  <td>
    <label class="form-checkbox u-m-0">
      <input type="checkbox" :checked="selected" v-on:click="select">
      <span class="form-checkbox__indicator"></span>
    </label>
  </td>
</template>

<script>
  export default {
    data: () => ({
      selected: false,
      isHeader: false,
      table: null,
      tableHeader: null
    }),
    mounted () {
      this.table = this.$parent.$parent
      this.tableHeader = this.table.$slots.header[0].componentInstance

      if (this.tableHeader === this.$parent) {
        this.isHeader = true
      }
    },
    methods: {
      select () {
        this.selected = !this.selected
      }
    },
    props: {
      data: {
        type: [Object, Array],
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Select.vue?8cabb0ce